import React, { Component } from 'react'
import './styles.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
  english: 'English',
  spanish: 'Spanish',
  french: 'French',
  copyright: 'US Server. Copyright ©{year} ViaPath Technologies. All rights reserved.',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service'
})

function Footer(props) {
  const {
    setLang,
    locale
  } = props

  const termsURL = process.env.TERMS_OF_SERVICE_URL || `https://legal.telmate.com/terms/${locale.toLowerCase()}`;
  const privacyURL = process.env.PRIVACY_POLICY_URL || `https://legal.telmate.com/privacy/${locale.toLowerCase()}`;

  return (
    <div styleName='footerContainer'>
      <Container>
        <Row>
          <Col xs={12} styleName='content'>
            <div styleName='footerLeft'>
              <div styleName='footerLinks'>
                <ul className='row'>
                  <li>
                    <a href={privacyURL} target='_blank'>
                      <FormattedMessage {...messages.privacyPolicy} />
                    </a>
                    <span>{' | '}</span>
                  </li>
                  <li>
                    <a href={termsURL} target='_blank'>
                      <FormattedMessage {...messages.termsOfService} />
                    </a>
                    <span>{' | '}</span>
                  </li>
                  <li>
                    <a data-testid='lang-english' onClick={() => setLang('en')}>
                      <FormattedMessage {...messages.english} />
                    </a>
                    <span>{' | '}</span>
                  </li>
                  <li>
                    <a data-testid='lang-spanish' onClick={() => setLang('es')}>
                      <FormattedMessage {...messages.spanish} />
                    </a>
                    <span>{' | '}</span>
                  </li>
                  <li>
                    <a data-testid='lang-french' onClick={() => setLang('fr')}>
                      <FormattedMessage {...messages.french} />
                    </a>
                  </li>
                </ul>
              </div>
              <div data-testid='copyright' className='copyright'>
                {process.env.COPYRIGHT_TEXT || (
                  <FormattedMessage {...messages.copyright} values={{ year: new Date().getFullYear() }} />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Footer
